// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__fSfQi","text-value":"styles_text-value__Q5_bv"};